import CONSTANTES from "../constantes";


export const actionGetCategorias = () => ({
    type: CONSTANTES.GET_CATEGORIAS
})

export const actionPutCategorias = categorias => ({
    type: CONSTANTES.PUT_CATEGORIAS,
    categorias,
})


export const actionAgregarCategoria = values => ({
    type: CONSTANTES.AGREGAR_CATEGORIA,
    values,
})

export const actionAddCategoria = categoria => ({
    type: CONSTANTES.ADD_CATEGORIA,
    categoria,
})


export const actionGetCatalogo=(filtros)=>({
    type:CONSTANTES.GET_CATALOGO,
    filtros
})
export const actionPutCatalogo=(catalogo)=>({
    type:CONSTANTES.PUT_CATALOGO,
    catalogo
})

export const actionAgregarProductoCatalogo=(values)=>({
    type:CONSTANTES.AGREGAR_PRODUCTO,
    values
})

export const actionEditarProducto=(idProducto,values)=>({
    type:CONSTANTES.EDITAR_PRODUCTO,
    values,
    idProducto
})


